import { useRef } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import IconButton from './IconButton';
import { Icon } from './Icons';
import { toggleVideo } from '../store/slices/deviceSlice';
import { debounce } from '../utils/functions';

function CameraButton() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const theme = useTheme();
  const { hideVideo } = useSelector((state) => state.device);
  const debouncedToggleVideo = useRef(
    debounce(() => dispatch(toggleVideo()), 200)
  ).current;

  const handleToggleVideo = () => {
    debouncedToggleVideo();
  };

  return (
    <Stack alignItems="center" width="100px">
      <IconButton
        onClick={handleToggleVideo}
        aria-label={hideVideo ? t('Turn camera on') : t('Turn camera off')}
        aria-pressed={!hideVideo}
      >
        <Icon
          name={hideVideo ? 'videoOff' : 'videoOn'}
          color={theme.palette.secondary.main}
        />
      </IconButton>
      <Typography
        sx={{
          textAlign: 'center',
          fontSize: '12px', // Adjust font size as needed
        }}
      >
        {hideVideo ? t('Turn on') : t('Turn off')}
      </Typography>
    </Stack>
  );
}

export default CameraButton;
